//REACT
import { useState } from 'react';
//CSS
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
//COMPONENTS
import Menu from './components/jsx/Menu';
import Animation from './components/jsx/Animation';
//IMAGES
import Bottom from "./images/bottom.jpg"
import Gaurill from "./images/gaurill.png"
import NewTemplate from "./images/newTemplate.png"

import Gmail from "./images/contact/gmail.png";
import Linkedin from "./images/contact/linkedin.png";
import Telegram from "./images/contact/telegram.png";

//ARRAYS
import { Answers } from './utils/Answers';

function App() {
  
  const res = Answers
  const [answer,setAnswer]= useState('Selecciona una pregunta');
  
  const r1 =(answer) =>{ setAnswer(answer = res[0].r1)};
  const r2 =(answer) =>{ setAnswer(answer = res[1].r2)};
  const r3 =(answer) =>{ setAnswer(answer = res[2].r3)};
  const r4 =(answer) =>{ setAnswer(answer = res[3].r4)};
  const r5 =(answer) =>{ setAnswer(answer = res[4].r5)};
  const r6 =(answer) =>{ setAnswer(answer = res[5].r6)};

  return (
    <div className="global_container" id='home'>
      <header>
      <Menu
        title="o o o"
        link1="#home"
        link2="#projects"
        link3="#contact"
        option1="Inicio"
        option2="Proyectos"
        option3="Contacto"
        ></Menu>
        
        <Menu
        title="language"
        link1="/"
        link2="/english"
        link3="/portuguese"
        option1="Español"
        option2="English"
        option3="Português"
        ></Menu>
      </header>
      <div className="container">

        <div className="container_1">

        <div className='container_presentation'>
        <div className="name">Mauro <br /> Calodolce</div>
        <div className="profession">Full Stack Developer</div>
        </div>

        <Animation
        first="#id"
        second=".env"
        third="(e)=>"
        fourth="<img>"
        fifth="<div>"
        ></Animation>
        
        <a href='#aboutMe' className='info' id='aboutMe' ><img className="info_img" src={Bottom} /></a>
    
        </div>
        <div className="container_2">
          <div className="titles">Sobre Mí</div>
          <div className="container2_presentation">
            <div className='container2_presentation_syntax'>
            A mis 20 años, soy Tecnico en Informatica, en camino a convertirme en Full Stack Developer. 
            En lo personal prefiero desenvolverme del lado del Front-End, sin embargo, puedo desempeñarme
            bien del lado del Back-end. Durante mis inicios en el desarrollo web 
            realice varias paginas exclusivamente con HTML y CSS, hasta que a mediados de 2021 
            me adentre en el mundo de la programacion, mas precisamente JavaScript y varios de sus respectivos 
            Frameworks. 
            </div>
        <div className='container2_presentation_questions'>

          <div className='container2_presentation_questions_questions'>
            <button id='r1' onClick={r1}>¿Porque elegiste inclinarte por el Desarrollo Web?</button>
            <button id='r2' onClick={r2}>¿Que educación tenés?</button>
            <button id='r3' onClick={r3}>¿Que tecnologias sabés utilizar?</button>
            <button id='r4' onClick={r4}>¿Cual es tu experiencia?</button>
            <button id='r5' onClick={r5}>¿Que idiomas dominás?</button>
            <button id='r6' onClick={r6}>¿Que priorizas al crear un proyecto?</button>
          </div>
          <div className='container2_presentation_questions_answers'>{answer}</div> 
        </div>
          </div>
        </div>
        <a href='#projects' className='info' id='projects' ><img className="info_img" src={Bottom} /></a>
        <div className="titles">Proyectos</div>

        <div className="container_3">
        <a href='http://gaurillcomics.vercel.app' target="_blank" className="container_3_project">
          <img src={Gaurill} className="container_3_img" />
          <div className="container_3_project_info">
            <div className="container_3_project_info_title">GaurillComics</div>
            <span className="container_3_projects_info_text">
              Desarrollada en un estilo Onepage , el objetivo del sitio web, es promocionar de manera 
              estética el trabajo de un ilustrador artistico, en donde los usuarios no solo podrán 
              visualizar el contenido, sino que tendran la posibilidad de contactarse con él.
            </span>
          </div>
        </a>

        <a href='http://newtemplate.vercel.app' target="_blank" className="container_3_project">
          <img src={NewTemplate} className="container_3_img" />
          <div className="container_3_project_info">
            <div className="container_3_project_info_title">New Template</div>
            <span className="container_3_projects_info_text">
              Un sitio web simple y practico, hecho para aquellos usuarios que no son muy amantes del front-end.
              NewTemplate le ofrece a sus visitantes plantillas web en HTML y CSS totalmente gratuitas 
              para poder elaborar un proyecto sin la necesidad de maquetar o bien salir de un apuro.
            </span>
          </div>
        </a>
        </div>
        <a href='#contact' className='info' id='contact' ><img className="info_img" src={Bottom} /></a>
        
        <div className="titles">Contacto</div> 
        <div className="container_4">
        <div className='container_4_contact'>
          
          <a href="mailto:maucalodolce20@gmail.com?Subject=Comunicacion" target="_BLANCK" className='container_4_contact_link'><img src= {Gmail} alt="Gmail" className='container_4_contact_img' /> <p className='container_4_contact_text'>Email</p></a>
          <a href="https://ar.linkedin.com/in/mauro-calodolce-208041223" target="_BLANCK" className='container_4_contact_link'><img src={Linkedin} alt="Linkedin" className='container_4_contact_img' /><p className='container_4_contact_text'>Linkedin</p></a>
          <a href="https://t.me/Maurocalo" target="_BLANCK" className='container_4_contact_link'><img src={Telegram} alt="Telegram" className='container_4_contact_img' /><p className='container_4_contact_text'>Telegram</p></a>
        </div>

        <div className="container_4_info">
         <div className='container_4_info_link'> <img src={Gmail} className="container_4_info_img" />maucalodolce20@gmail.com</div>
         <div className='container_4_info_link'> <img src={Telegram} className="container_4_info_img" />@MauroCalo</div>
         <div className='container_4_info_link'> <img src={Linkedin} className="container_4_info_img" />Mauro Calodolce</div>
        </div>
          
        </div>
        
      </div>
      <footer>

      <div className="footer_info">
          Este sitio web fue desarrollado con React Js.
          al igual que las páginas que se exhíben en la sección de <b>Proyectos</b>. <br />
          ©Copyright 2022 | Mauro Calodolce
        </div>
        <div className="footer_options">
          <a href="#home" className='footer_options_option'>Inicio</a>
          <a href="#aboutMe" className='footer_options_option'>Sobre Mí</a>
          <a href="#projects" className='footer_options_option'>Proyectos</a>
          <a href="#contact" className='footer_options_option'>Contacto</a>
        </div>
      <div className="footer_info">
          Para cambiar la traducción del sitio web puede seleccionar
          la ventana de <b>Language</b> en la parte superior derecha.
          Todas las traducciónes del sitio web, son de autoría propia.
        </div>

      </footer>      
    </div>

  );
}

export default App;
